import { elementEventFullName } from '@angular/compiler/src/view_compiler/view_compiler';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PaginationNumberLinkContext } from 'ngx-bootstrap/pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { IEdificios } from '../interfaces/Edificios';
import { IFiltrosListadoClientes } from '../interfaces/FiltrosListadoClientes';
import { IMeses } from '../interfaces/IMeses';
import { IMarcas } from '../interfaces/Marcas';
import { IMonitorVentasCertificadas } from '../interfaces/MonitorVentasCertificadas';
import { ExcelService } from '../Services/excel.service';
import { RegistroVentasService } from '../Services/registro-ventas.service';


@Component({
  selector: 'app-reportecliente-ventas-certificadas',
  templateUrl: './reportecliente-ventas-certificadas.component.html',
  styleUrls: ['./reportecliente-ventas-certificadas.component.css']
})
export class ReporteclienteVentasCertificadasComponent implements OnInit {
  myForm: FormGroup;
  marcas: IMarcas[];
  edificios: IEdificios[];
  resultadoConsulta: IMonitorVentasCertificadas[];
  edificio: string;
  marca: string;
  annios: Array<number> = [];
  anio: string;
  filtros: IFiltrosListadoClientes;
  submitted = false;
  meses: Array<IMeses> = [];
  mes: string;
  periodo: string;

  tiposContrato = [
    { id: 'Fijo', name: 'Fijo' },
    { id: 'Variable', name: 'Variable' }
  ];

  estadosContrato = [
    { id: 'Aprobado', name: 'Aprobado' },
    { id: 'Rechazado', name: 'Rechazado' },
    { id: 'Pendiente', name: 'Pendiente' }
  ];

  constructor(private fb: FormBuilder,
    private registroServicios: RegistroVentasService,
    private spinner: NgxSpinnerService,
    private excelService: ExcelService) { }

  ngOnInit(): void {
    this.cargaEdificios(environment.edificiosAutorizados, environment.marcasAutorizadas);
    this.cargaMarcas();
    this.cargaAnnio();
    this.cargarMeses();

  }

  cargaAnnio() {
    var annioActual = new Date().getFullYear();

    for (let i = 2017; i <= annioActual; i++) {
      this.annios.push(i);
    }

  }

  cargaEdificios(edificios: string, marcas: string) {
    this.registroServicios.getEdificiosRegistro(edificios, marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.edificios = resolve;
        }

      },
      (error: ErrorResponse) => {
        console.error(error);
      }
    );
  }



  cargaMarcas() {
    this.registroServicios.obtenerMarcas().subscribe(
      resolve => {
        if (resolve != null) {
          this.marcas = resolve;
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'No se cargaron los marcas...',
            text: 'Valide con el administrador.'
          })
        }

      },
      (error: ErrorResponse) => {
        console.log(error);
      }
    );
  }

  getListadoClientes(): void {
    this.spinner.show();
    if (this.edificio == "Todos") {
      this.edificio = "";
      let edificiosArr = environment.edificiosAutorizados.split(",");
      edificiosArr.forEach(element => {
        this.edificio += "'" + element + "',"
      });
      this.edificio = this.edificio.slice(1, -2);

    }

    if (this.mes == "Todos") {
      this.periodo = "Todos";
    }
    else {
      this.periodo = this.anio + this.mes
    }
    
    this.filtros = {
      Edificio: this.edificio,
      Annio: this.anio,
      Marca: this.marca,
      Periodo: this.periodo
    }


    this.registroServicios.obtenerListadoClientes(this.filtros).subscribe(
      resolve => {
        if (resolve != null && resolve.length > 0) {
          this.excelService.exportAsExcelFile(resolve, 'reporte_ventas_certificadas');
        }
        else {
          Swal.fire('No se encontraron registros.');

        }
        this.spinner.hide();
      },
      (error: ErrorResponse) => {
        console.log(error);
        this.spinner.hide();
      }
    );
  }



  onSubmit() {
    this.submitted = true;
    if (this.marca == undefined) {
      return;
    }
    if (this.edificio == undefined) {
      return;
    }
    if (this.marca == 'Todos' && this.edificio == 'Todos') {
      return;
    }
    if (this.anio == undefined) {
      return;
    }
    else {
      this.getListadoClientes();
    }
  }

  cargarMeses() {
    this.meses.push(
      { Value: '1', Text: 'Enero' },
      { Value: '2', Text: 'Febrero' },
      { Value: '3', Text: 'Marzo' },
      { Value: '4', Text: 'Abril' },
      { Value: '5', Text: 'Mayo' },
      { Value: '6', Text: 'Junio' },
      { Value: '7', Text: 'Julio' },
      { Value: '8', Text: 'Agosto' },
      { Value: '9', Text: 'Septiembre' },
      { Value: '10', Text: 'Octubre' },
      { Value: '11', Text: 'Noviembre' },
      { Value: '12', Text: 'Diciembre' }
    );
  }


}
